import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'
import { isAuthorshipFieldName } from '@next-adapter/generators/actions/action-helpers/is-authorship-field-name.js'
export function isActionField(field: SchemaField, exclusions: Set<string>): boolean {
  return (
    !field.primaryKey &&
    !exclusions.has(field.name) &&
    !isAuthorshipFieldName(field.name) &&
    !isLayoutField(field.type)
  )
}
